import React from 'react';

const July4thDecorations = () => {
  // Generate stars
  const stars = Array.from({ length: 30 }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    top: Math.random() * 100,
    delay: Math.random() * 4,
    size: 8 + Math.random() * 16,
    color: i % 3 === 0 ? '#FF0000' : i % 3 === 1 ? '#FFFFFF' : '#0000FF',
  }));

  // Generate firework bursts
  const fireworks = Array.from({ length: 8 }, (_, i) => ({
    id: i,
    left: 10 + Math.random() * 80,
    top: 10 + Math.random() * 40,
    delay: Math.random() * 6,
    size: 40 + Math.random() * 40,
  }));

  return (
    <div className="fixed inset-0 pointer-events-none z-40 overflow-hidden">
      {/* Twinkling stars */}
      {stars.map((star) => (
        <div
          key={`star-${star.id}`}
          className="absolute animate-twinkle"
          style={{
            left: `${star.left}%`,
            top: `${star.top}%`,
            fontSize: `${star.size}px`,
            animationDelay: `${star.delay}s`,
            filter: `drop-shadow(0 0 4px ${star.color})`,
          }}
        >
          ⭐
        </div>
      ))}

      {/* Firework bursts */}
      {fireworks.map((fw) => (
        <div
          key={`firework-${fw.id}`}
          className="absolute animate-firework"
          style={{
            left: `${fw.left}%`,
            top: `${fw.top}%`,
            width: `${fw.size}px`,
            height: `${fw.size}px`,
            animationDelay: `${fw.delay}s`,
          }}
        >
          <div className="relative w-full h-full">
            {[...Array(8)].map((_, i) => (
              <div
                key={i}
                className="absolute w-2 h-2 rounded-full bg-current animate-firework-particle"
                style={{
                  left: '50%',
                  top: '50%',
                  color: i % 3 === 0 ? '#FF0000' : i % 3 === 1 ? '#FFFFFF' : '#0000FF',
                  transform: `rotate(${i * 45}deg) translateY(-${fw.size / 2}px)`,
                  animationDelay: `${fw.delay}s`,
                }}
              />
            ))}
          </div>
        </div>
      ))}

      {/* Red, white, blue banner at top */}
      <div className="absolute top-0 left-0 right-0 h-1 flex">
        <div className="flex-1 bg-red-600 opacity-60" />
        <div className="flex-1 bg-white opacity-60" />
        <div className="flex-1 bg-blue-600 opacity-60" />
      </div>
    </div>
  );
};

export default July4thDecorations;
